import Css from './Css.js';
import TimeSlider from './TimeSlider/TimeSlider.js';
import TimeScale from './TimeScale/TimeScale.js';
import PlayLine from './PlayLine/PlayLine.js';
import PaintBoard from './PaintBoard/PaintBoard.js';
import SelectLine from './SelectLine/SelectLine.js';
import orderUtil from '../Utils/orderUtil.js';
import drawLineUtil from '../Utils/DrawLine.js';
import throttle from 'lodash.throttle';
import { useState } from 'react';

//中间创建Pattern的整个大组件
function PatternBox(props){
  const {
    points,middleWidth,videoEl,lvsPatternEditorId,editorMode,editPointPositionArr,progress,
    batchSelPointPositionArr,timeScaleInfo,sldivPosition,copyArr,editMenuInfo,videoTotalTime,
    isSelectLine,selStartTime,selEndTime,timeLinePosition,selEditPointsArr,mouseDownType
  } = props.data;
  const {
    setCopyArr,pauseVideo,setPoints,setCanvasMouseMoveXLeft,showCopyPoints,
    hideCopyPaste,setMouseDownType,setEditPointPositionArr,setEditMenuInfo,setIsSelectLine,
    setSldivPosition,setTimeLinePosition,setSelStartTime,setSelEndTime,setTimeScaleInfo
  } = props.method;
  const tsInfo = {...timeScaleInfo, middleWidth, videoTotalTime };
  const editorEl = document.getElementById(lvsPatternEditorId);
  const editorCanvasId = lvsPatternEditorId + "_canvas";
  let editorCanvas = document.getElementById(editorCanvasId);
  //鼠标移入canvas内所处位置对应的时间
  const [pasteStartTime, setPasteStartTime] = useState(-1);

  const getMousePointTime = (time)=>{
    return parseInt(((time/(middleWidth-12))*(selEndTime-selStartTime)) + selStartTime)
  }

  const getxLeft = (prevX)=>{
    let editorLeft = document.getElementById(lvsPatternEditorId).getBoundingClientRect().left;
    let res = prevX - editorLeft - 160 - 6;
    return res;
  }

  //编辑模式下，双击曲线点，则删除点中的点
  const canvasDBClick = (e) => {
    if(editorMode.edMode === 2){
      if(!isSelectLine){  //进入复制粘贴模式的时候不允许双击删除点
        if(editorCanvas){
          editorCanvas.onmousedown = null;
          editorCanvas.onmousemove = null;
        }
        pauseVideo();
        let prevX = e.clientX;
        let xLeft = getxLeft(prevX);
        let selTime = selEndTime - selStartTime;
        let mdWidth = middleWidth - 12;
        let findPoint = null;
        let currentPointTime = getMousePointTime(xLeft);
        let realPt = Math.round((currentPointTime/100))*100;
        let tmpPointsArr = orderUtil.deepClone(points);
        let findTmp = tmpPointsArr.find((value,index,tmpPointsArr)=>{ return tmpPointsArr[index].t === realPt });
        if(findTmp){
          findPoint = findTmp; //直接双击选中了点
        }else{
          //没有选中点则寻找附近点
          let time1 = parseInt(((xLeft-4)/mdWidth)*selTime + selStartTime);
          let time2 = parseInt(((xLeft+4)/mdWidth)*selTime + selStartTime);
          for(let i=0; i<tmpPointsArr.length; i++){
            let cp = tmpPointsArr[i];
            if(cp.t > time1 && cp.t < time2){
              findPoint = cp;
            }
          }
        }
        if(findPoint){  //删除点
          let p = orderUtil.getPointIndex(tmpPointsArr, findPoint.t);
          tmpPointsArr.splice(p,1);
          setPoints(tmpPointsArr);
        }
      }
    }
  }
  
  const canvasMouseUp = (e)=> {
    if(isSelectLine && sldivPosition){
      if(mouseDownType && mouseDownType === "right"){
        //显示右键菜单
        return;
      }
      //进入复制粘贴模式，显示批量选中的点以及右键菜单
      showCopyPoints();
      let mouseUpX = getxLeft(e.clientX);
      let w1 = sldivPosition.marginLeft;
      let w2 = sldivPosition.width + sldivPosition.marginLeft;
      if((mouseUpX < w1 || mouseUpX > w2) && mouseDownType === "left"){
        //没有选中点，隐藏选区
        hideCopyPaste();
      }
    }
  }
  
  const getChangePoints = (time1, time2) => {
    let pointLength = points.length;
    if(pointLength > 0){
      let resArr = [];
      let index = -1;
      for(let i=0; i<pointLength; i++){
        if(points[i].t > time1 && points[i].t < time2){
          resArr.push(points[i]);
          if(index < 0){
            index = i;
          }
        }
      }
      return { points:resArr, position:index };
    }
    return null;
  }

  //修改曲线
  //以当前鼠标位置，向左向右各40px取点，找出中间点为初始参照点
  //中间点的level变化根据鼠标水平移动的距离算出
  const changePointLevel = (pointArr,currentPointTime,spaceTime,moveY,mdLevel,bkArr) => {

    let maxLevel = 20;
    let maxChange = parseInt(moveY/(orderUtil.canvasHeight/maxLevel/2));
    let middlePoint = null;
    //判断是否直接选中当前点
    let realPt = Math.round((currentPointTime/100))*100;
    let findTmp = points.find((value,index,points)=>{ return points[index].t === realPt });
    if(findTmp){
      middlePoint = findTmp;
    }else{
      let middlePointArr = [];
      let tsLeft = currentPointTime - spaceTime;
      let tsRight = currentPointTime + spaceTime;
      //从鼠标位置左右10等份(共20份)计算，找出距离鼠标最近的第一个点，叫做middlePoint
      for(let i=0; i<pointArr.length; i++){
        if(pointArr[i].t > tsLeft && pointArr[i].t < tsRight){
          middlePointArr.push(pointArr[i]);
        }
      }
      if(middlePointArr.length > 0){
        if(middlePointArr.length === 1){
          middlePoint = middlePointArr[0];
        }else{
          let mpIndex = Math.floor(middlePointArr.length/2);
          middlePoint = middlePointArr[mpIndex];
        }
      }
    }
    if(middlePoint){
      let oldV = middlePoint.v;
      let tmpCanvasMDPoints = [...bkArr];
      let mdpTime = middlePoint.t;
      let mdTmpPoint = tmpCanvasMDPoints.find((value2,index2,points2)=>{ return tmpCanvasMDPoints[index2].t === mdpTime });
      if(mdTmpPoint){
        oldV = mdTmpPoint.v;
      }
      //中间点位置
      let newPsArr = [];
      let tmpMp = middlePoint;
      tmpMp.v = orderUtil.limitLevel(Math.ceil(oldV + maxChange*0.7));
      
      newPsArr.push(tmpMp);
      let tPoints = orderUtil.deepClone(points);
      let firstPos = orderUtil.getPointIndex(tPoints, newPsArr[0].t);
      let lastPos = orderUtil.getPointIndex(tPoints, newPsArr[newPsArr.length-1].t);
      let leftPointsArr = tPoints.slice(0, firstPos);
      let rightPointsArr = tPoints.slice(lastPos+1);
      let allArr = leftPointsArr.concat(newPsArr);
      allArr = allArr.concat(rightPointsArr);
      setPoints(allArr);
    }else{  
      //没有中间点则需要生成新点
      let tPoints = orderUtil.deepClone(points);
      let cLevel = orderUtil.limitLevel(parseInt(mdLevel + (maxChange*0.8)));
      let ct = orderUtil.formatMs(currentPointTime);
      //如果新建中间点与两侧的点，相隔少于0.1s，则用前一个点替换当前新建点
      let canInsertPoint = false;
      let index = 0;
      for(let i=0; i<tPoints.length-1; i++){
        let cp = tPoints[i];
        if(ct > cp.t){
          index = i;
          if(tPoints[i+1].t > ct){
            canInsertPoint = true;
          }
        }
      }
      if(canInsertPoint){
        let addPoint = { t:ct, v:cLevel };
        tPoints.push(addPoint);
        tPoints.sort((a, b) => a.t - b.t);
        setPoints(tPoints);
      }else{
        tPoints[index].v = cLevel;
        setPoints(tPoints);
      }
    }
  }

  //按下鼠标上下拖动，则根据鼠标移动位置改变曲线点
  //编辑模式下，在canvas上按下鼠标左键
  const canvasMouseDown = (e)=> {
    let btnType = "";
    if(e.button === 0){
      btnType = "left";
    }else if(e.button === 2){
      btnType = "right";
    }
    setMouseDownType(btnType);
    if(editorMode.edMode === 2){
      pauseVideo();
      let bkArr = orderUtil.deepClone(points);
      let prevX = e.clientX;
      let prevY = e.clientY;
      let editorTop = editorEl.offsetTop;  //editor元素到浏览器顶部的距离
      let xLeft = getxLeft(prevX);
      let scrollTop = document.documentElement.scrollTop; //页面滚动隐藏的距离

      //计算鼠标摁下位置的震动level
      let xTop = prevY - (editorTop - scrollTop) - 80 - 80 - 2;
      let mdLevel = orderUtil.getLevel(orderUtil.canvasHeight - 17 - xTop);
      let tmpHeight = orderUtil.canvasHeight - 17 - xTop;
      let noLimitLevel = orderUtil.getLevel(tmpHeight, orderUtil.coMinHeight, orderUtil.coMaxHeight, false);
      let currentPointTime = getMousePointTime(xLeft);

      //根据鼠标位置的noLimitLevel和currentPointTime，
      //判断鼠标落点是否在曲线附近（左右7px，上下3个level）
      //如果是，则认为用户要拖拽修改曲线；如果不是，则认为用户要按下拖拉鼠标做批量选点操作
      let changeType = 2; //1编辑曲线  2批量选择曲线点
      let canvasWidth = 604;
      const pts = bkArr.reduce((p, { v, t }) => {
        let x = parseInt(((t - selStartTime) / (selEndTime - selStartTime)) * canvasWidth);
        let y = parseInt(((((20 - v) / 20) * orderUtil.canvasHeight) / 4) * 2.94 + orderUtil.canvasHeight / 7.2);
        p.push(x);
        p.push(y);
        return p;
      }, []);
      let lineData = drawLineUtil.getCurvePoints(pts, null, false, 16);
      let mouseX = parseInt(((currentPointTime - selStartTime) / (selEndTime - selStartTime)) * canvasWidth);
      let mouseY = parseInt(((((20 - noLimitLevel) / 20) * orderUtil.canvasHeight) / 4) * 2.94 + orderUtil.canvasHeight / 7.2);

      //遍历曲线判断鼠标是否在曲线上
      for(let b=0; b<lineData.length-2; b=b+2){
        let xx = lineData[b];
        let yy = lineData[b+1];
        if(Math.abs(xx-mouseX) < 7){
          //mouseY范围是29-169，(169-29)/20=7px一个level
          //故 < 12 的意思是控制鼠标可选范围的Y距离为不超过3个level, 跟<11, <10, ... <8是同样作用。
          if(Math.abs(yy-mouseY) < 7){
            changeType = 1;
            break;
          }
        }
      }
      //根据鼠标落点位置，计算显示点范围（左右40px）
      let time2 = getMousePointTime(xLeft - 40);
      let time1 = getMousePointTime(xLeft + 40);
      //计算出鼠标位置左右40px两点之间的时间差，然后分成20等分，算出每一份包含的时间量
      let spaceTime = parseInt((time1 - time2) / 20);
      //寻找符合条件需要修改的点数组，及起始位置
      let pObj = getChangePoints(time1, time2);
      if(editorCanvas){
        editorCanvas.onmousemove = throttle(function(ev) {
          let moveY = prevY - ev.clientY;
          //判断是否在选区内左键移动鼠标，如果是则整体上下拖动曲线，如果不是则重新计算选区
          let mousePosx = xLeft;
          let sldivLeft = sldivPosition.marginLeft;
          let sldivRight = sldivPosition.marginLeft + sldivPosition.width;
          if(mousePosx >= sldivLeft && mousePosx <= sldivRight && sldivPosition.show){
            //上下拖动曲线
            let mdLevel2 = Math.ceil(moveY/8); //每次上下拖到最大修改10个等级
            let changePointArr = [];
            for(let i=0; i<selEditPointsArr.length; i++){
              let cpObj = {};
              cpObj.t = selEditPointsArr[i].t;
              cpObj.v = orderUtil.limitLevel(selEditPointsArr[i].v + mdLevel2);
              changePointArr.push(cpObj);
            }
            //合并数组，计算新曲线
            if(changePointArr.length > 0){
              let bkPointsArr = orderUtil.deepClone(points);
              let index1 = orderUtil.getPointIndex(bkPointsArr, selEditPointsArr[0].t);
              let index2 = orderUtil.getPointIndex(bkPointsArr, selEditPointsArr[selEditPointsArr.length-1].t);
              if(index1 > 0 && index2 > 0){
                let leftArr = bkPointsArr.slice(0, index1);
                let rightArr = bkPointsArr.slice(index2+1);
                let newArr = leftArr.concat(changePointArr).concat(rightArr);
                setPoints(newArr);
              }
            }
          }else if(changeType === 1){
            hideCopyPaste();
            if(pObj){
              changePointLevel(pObj.points,currentPointTime,spaceTime,moveY,mdLevel,bkArr);
            }
          }else{
            if(btnType === "left"){
              //选择需要批量复制的点
              setEditMenuInfo({...editMenuInfo, "show":false, "btn":"clear,copy,paste,cancel"});
              setEditPointPositionArr([]);
              setIsSelectLine(true);
              let marginLeft = 0;
              let moveX = 0;
              if(prevX > ev.clientX){
                moveX = prevX - ev.clientX;
                marginLeft = getxLeft(ev.clientX);
              }else{
                moveX = ev.clientX - prevX;
                marginLeft = getxLeft(prevX);
              }
              if(moveX > 0){
                //计算复制区域的起止时间
                let w1 = marginLeft;
                let w2 = parseInt(marginLeft + moveX);
                let selTime = selEndTime - selStartTime;
                let divStartTime = parseInt((w1/middleWidth)*selTime) + selStartTime;
                let divEndTime = parseInt((w2/middleWidth)*selTime) + selStartTime;
                setSldivPosition({ width:moveX,marginLeft,divStartTime,divEndTime,show:true });
              }
            }
          }
          editorCanvas.onmouseup = function(){
            editorCanvas.onmousedown = null;
            editorCanvas.onmousemove = null;
          };
          return false;
        }, 30);
      }
    }
  }

  
  const canvasMouseMove = throttle((e)=>{
    let prevX = e.clientX;
    let xLeft = getxLeft(prevX);
    setCanvasMouseMoveXLeft(xLeft);
    let selTime = selEndTime - selStartTime;
    let mdWidth = middleWidth - 12;
    let pt = parseInt((xLeft/mdWidth)*selTime + selStartTime);
    let pasteStartTime = orderUtil.formatMs(pt);
    if(pasteStartTime >= 0){
      setPasteStartTime(pasteStartTime);
    }
    if(editorMode.edMode === 2){
      if(!sldivPosition.show){
        //寻找当前鼠标位置pt附近的点，高亮显示编辑点
        let tmpPointsArr = orderUtil.deepClone(points);
        let tmpPoint = tmpPointsArr.find((value,index,tmpPointsArr)=>{ return tmpPointsArr[index].t > pt });
        if(tmpPoint){
          let pos = orderUtil.getPointIndex(tmpPointsArr, tmpPoint.t);
          if(pos >= 3 && pos < tmpPointsArr.length - 3){
            let parr = [];
            for(let i=pos-3; i<=pos+3; i++){
              let p = orderUtil.getPointIndex(tmpPointsArr, tmpPointsArr[i].t);
              //由DrawLine的getCurvePoints方法可知，一个关键点最终被算法生成了34个点
              //所以这里在真实数据点的位置下标，乘以34，才知道当前传入的点最终位于曲线中的具体位置
              parr.push(p*34);
            }
            setEditPointPositionArr(parr);
          }
        }
      }else{
        //进入复制粘贴模式，显示批量选中的点
        showCopyPoints();
      }
      return false;
    }
  }, 20);

  //点击时间刻度尺
  const clickTimeScale = (e) => {
    pauseVideo();
    setTimeout(()=>{
      let clientX = e.clientX;
      let xLeft = getxLeft(clientX);
      let selTime = selEndTime - selStartTime;
      let moveTime = (xLeft/(middleWidth-12))*selTime;
      let tmpCurTime = parseInt((parseInt(selStartTime + moveTime))/1000);
      if(tmpCurTime || tmpCurTime === 0){
        videoEl.currentTime = tmpCurTime;
      }else{
        console.error("点击时间刻度尺出现异常:");
        console.error("selStartTime=",selStartTime," selEndTime=",selEndTime," middleWidth=",middleWidth," xLeft=",xLeft);
      }
    },50);
  }
  //点击画布事件
  const clickCanvas = (e) => {
    if(editorMode.edMode !== 2){   
      clickTimeScale(e);
    }
  }
  const canvasDivMouseLeave = ()=> {
    //清除关键点
    setEditPointPositionArr([]);
    if(editorCanvas){
      editorCanvas.onmousedown = null;
      editorCanvas.onmousemove = null;
    }
  }

  const canvasMouseLeave = (e) => {
    setPasteStartTime(-1);
  }

  return (
    <>  
      <div style={Css.getPatternSty(middleWidth)}>
        <TimeScale 
          clickTimeScale={ (e)=>{ clickTimeScale(e) } }
          tsInfo={tsInfo}
        ></TimeScale>
        <TimeSlider
          data={{middleWidth,videoEl,selStartTime,selEndTime,timeScaleInfo,lvsPatternEditorId,timeLinePosition,videoTotalTime}}
          method={{pauseVideo,hideCopyPaste,setTimeLinePosition,setSelStartTime,setSelEndTime,setTimeScaleInfo}}>
        </TimeSlider>
        <PlayLine 
          data={{videoEl,middleWidth,editorEl,selStartTime,selEndTime,progress}} 
          method={{pauseVideo}}>
        </PlayLine>
        <SelectLine
          data={{sldivPosition,editMenuInfo,points,selEditPointsArr,setPoints,copyArr,selStartTime,selEndTime,middleWidth,pasteStartTime}}
          method={{hideCopyPaste,setCopyArr}}
        ></SelectLine>
        <PaintBoard 
          data={{points,selStartTime,selEndTime,middleWidth,lvsPatternEditorId,editorMode,editPointPositionArr,batchSelPointPositionArr}}
          method={{canvasMouseUp,canvasMouseDown,canvasMouseMove,canvasDBClick,clickCanvas,canvasDivMouseLeave,canvasMouseLeave}}>
        </PaintBoard>
      </div>
    </>
  )
}

export default PatternBox;